module.exports = __webpack_public_path__ + "static/media/5 (1).7c3e66bb.webp";